<template>
  <div class="show-vocal-audiometry pt-2 pb-3">
    <div class="row">
      <div class="col-md-6 pl-0">
        <h6 class="is-bold text-evollu-gray-light mb-3">
          {{ title }}
        </h6>
      </div>

      <div class="col-md-6 text-right" v-if="value && value.updated_at !== null && value.updated_at !== undefined">
        <small>
          {{ $t('clinical.people.anamnesis.updated_at') }}
        </small>
        <small class="is-bold">
          {{$t('clinical.people.anamnesis.updated_by', {date: getExpressiveDate(value.updated_at), name: value.updated_by ? value.updated_by.name : ''})}}
        </small>
      </div>
    </div>

    <section v-if="value !== null && value !== undefined" class="px-2">

      <!-- Right Ear Discrimination -->
      <div class="answer-wrapper">
        <label>
          {{$t('clinical.people.anamnesis.right_ear_discrimination')}}:
        </label>
        <span class="is-bold">
          {{getTextAnswer(value.right_ear_discrimination)}}
        </span>
      </div>

      <!-- Right Ear SRT -->
      <div class="answer-wrapper">
        <label>
          {{$t('clinical.people.anamnesis.right_ear_srt')}}:
        </label>
        <span class="is-bold">
          {{getTextAnswer(value.right_ear_srt)}}
        </span>
      </div>

      <!-- Right Ear Masking -->
      <div class="answer-wrapper">
        <label>
          {{$t('clinical.people.anamnesis.right_ear_masking')}}:
        </label>
        <span class="is-bold">
          {{getBooleanAnswer(value.right_ear_masking)}}
        </span>
      </div>

      <!-- Left Ear Discrimination -->
      <div class="answer-wrapper">
        <label>
          {{$t('clinical.people.anamnesis.left_ear_discrimination')}}:
        </label>
        <span class="is-bold">
          {{getTextAnswer(value.left_ear_discrimination)}}
        </span>
      </div>

      <!-- Left Ear SRT -->
      <div class="answer-wrapper">
        <label>
          {{$t('clinical.people.anamnesis.left_ear_srt')}}:
        </label>
        <span class="is-bold">
          {{getTextAnswer(value.left_ear_srt)}}
        </span>
      </div>

      <!-- Left Ear Masking -->
      <div class="answer-wrapper">
        <label>
          {{$t('clinical.people.anamnesis.left_ear_masking')}}:
        </label>
        <span class="is-bold">
          {{getBooleanAnswer(value.left_ear_masking)}}
        </span>
      </div>

      <!-- Vocal Audiometry Obs -->
      <div class="answer-wrapper">
        <label>
          {{$t('clinical.people.anamnesis.tonal_audiometry_obs')}}:
        </label>
        <span class="is-bold">
          {{getTextAnswer(value.obs)}}
        </span>
      </div>

    </section>

    <section v-else class="px-2">
      <span>{{$t('clinical.people.no_data')}}</span>
    </section>
  </div>

</template>

<script>
import * as AnamnesisOptions from './AnamnesisOptions'
export default {
  props: {
    value: {
      type: Object,
      required: false
    },
    title: {
      type: String,
      required: false,
      default: function () {
        return this.$t('clinical.people.anamnesis.vocal_audiometry')
      }
    }
  },
  data: function () {
    return {
      formOptions: AnamnesisOptions
    }
  },
  methods: {
    getExpressiveDate: function (value) {
      if (value) {
        if (this.$options.filters.isToday(value)) {
          return this.$t('date_helpers.today')
        } else {
          return this.$options.filters.localTime(value, `DD [${this.$t('date_helpers.day_of_month_separator')}] MMMM [${this.$t('date_helpers.day_of_month_separator')}] YYYY`, '', this.locale)
        }
      }
      return ''
    },
    getTextAnswer: function (answer, defaultValue = 'N/A') {
      return answer || defaultValue
    },
    getBooleanAnswer: function (answer, defaultValue = 'N/A') {
      return answer === null ? defaultValue : (answer === true ? this.$t('yes') : this.$t('no'))
    },
    getSingleOptionAnswer: function (options, answerId, defaultValue = 'N/A') {
      let option = null
      if (answerId !== null) {
        option = options.find(option => option.id === answerId)
        if (option) {
          option = this.$t(option.name)
        }
      }
      return option || defaultValue
    }
  }
}
</script>
<style lang="scss">

@mixin for-desktop {
  @media (min-width: 766px) {
    @content;
  }
}

.answer-wrapper {
  display: flex;
  flex-direction: column;
  margin-bottom: 0.75rem;
  justify-content: flex-start;

  label {
    margin-bottom: 0rem;
  }

  @include for-desktop {
    flex-direction: row;
    align-items: center;

    label {
      max-width: 80%;
    }

    span {
      margin-left: 0.25rem;
    }
  }
}

</style>
